"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zipPayMessages = exports.zipCodeFieldMessages = exports.stateFieldMessages = exports.payPalMessages = exports.nameErrorFieldMessages = exports.modalMessages = exports.inputFormInstruction = exports.getZipCodePropsObj = exports.getStatePropsObj = exports.getCityPropsObj = exports.fieldsMessages = exports.fieldsErrorMessages = exports.countryFieldMessages = exports.cityFieldMessages = exports.cardNumberFieldMessages = exports.cardExpiryFieldMessages = exports.cardCVVFieldMessages = exports.addressLineTwoPropsObj = exports.addressLineTwoFieldMessages = exports.addressLinePropsObj = exports.addressLineFieldMessages = void 0;
var _reactIntl = require("react-intl");
var fieldsMessages = (0, _reactIntl.defineMessages)({
  firstNameLabel: {
    id: 'inputField.label.firstName',
    description: 'Label for First name field',
    defaultMessage: 'First name'
  },
  lastNameLabel: {
    id: 'inputField.label.lastName',
    description: 'Label for Last name field',
    defaultMessage: 'Last name'
  },
  emailFieldLabel: {
    id: 'inputField.label.Email',
    description: 'Label for Email field',
    defaultMessage: 'Email'
  },
  phoneNumberFieldLabel: {
    id: 'inputField.label.phoneNumber',
    description: 'Label for Phone number field',
    defaultMessage: 'Phone number'
  },
  firstNamePlaceholder: {
    id: 'inputField.placeholder.firstName',
    description: 'Label for First name field',
    defaultMessage: 'John'
  },
  lastNamePlaceholder: {
    id: 'inputField.placeholder.lastName',
    description: 'Label for First name field',
    defaultMessage: 'Doe'
  },
  emailFieldPlaceholder: {
    id: 'inputField.placeholder.email',
    description: 'Label for First name field',
    defaultMessage: 'john.doe@cashstar.com'
  },
  phoneNumberFieldPlaceholder: {
    id: 'inputField.placeholder.phoneNumber',
    description: 'Label for First name field',
    defaultMessage: 'Enter phone number'
  },
  fullNameLabel: {
    id: 'inputField.label.fullName',
    description: 'Label for Full name field',
    defaultMessage: 'Name on Card'
  },
  fullNamePlaceholder: {
    id: 'inputField.placeholder.fullName',
    description: 'Label for Full name placeholder',
    defaultMessage: 'John Doe'
  },
  saveCardLabel: {
    id: 'inputField.label.saveCardLabel',
    description: 'Label for Save card field',
    defaultMessage: 'Save for later'
  },
  makeAsDefaultLabel: {
    id: 'inputField.label.makeAsDefaultLabel',
    description: 'Label for make as default',
    defaultMessage: 'Mark as default'
  }
});
exports.fieldsMessages = fieldsMessages;
var fieldsErrorMessages = (0, _reactIntl.defineMessages)({
  incompleteField: {
    id: 'inputField.errorMessage.incompleteField',
    description: 'Error message if a required field is kept empty',
    defaultMessage: 'Incomplete field'
  },
  exceedsMaxChracters: {
    id: 'inputField.errorMessage.exceedsMaxCharacters',
    description: 'Error message if any field exceeds maximum characters',
    defaultMessage: 'Exceeds {max} characters'
  },
  exceedsNameOnCardMaxCharacters: {
    id: 'inputField.errorMessage.exceedsNameOnCardMaxCharacters',
    description: 'Error message if name on card exceeds maximum characters',
    defaultMessage: 'Name on card is too long. Please enter {max} characters or less.'
  },
  emptyFirstName: {
    id: 'inputField.errorMessage.emptyFirstName',
    description: 'Error message if first name is empty',
    defaultMessage: 'Enter your first name'
  },
  emptyLastName: {
    id: 'inputField.errorMessage.emptyLastName',
    description: 'Error message if last name is empty',
    defaultMessage: 'Enter your last name'
  },
  emptyEmail: {
    id: 'inputField.errorMessage.emptyEmail',
    description: 'Error message if email is empty',
    defaultMessage: 'Enter your email address'
  },
  emptyPhone: {
    id: 'inputField.errorMessage.emptyPhone',
    description: 'Error message if phone is empty',
    defaultMessage: 'Enter your phone number'
  },
  invalidEmail: {
    id: 'inputField.errorMessage.pleaseEnterAValidEmailAddress',
    description: 'Error message if email field is invalid',
    defaultMessage: 'Enter your email address in the correct format, like name@example.com'
  },
  invalidPhoneNumber: {
    id: 'inputField.errorMessage.pleaseEnterAValidPhoneNumber',
    description: 'Error message if phone number field is invalid',
    defaultMessage: 'Enter a valid phone number'
  },
  emptyNameOnCard: {
    id: 'inputField.errorMessage.emptyNameOnCard',
    description: 'Error message if name on card is empty',
    defaultMessage: 'Enter the name on the payment card'
  },
  invalidFirstName: {
    id: 'inputField.errorMessage.pleaseEnterAValidFirstName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid first name'
  },
  invalidLastName: {
    id: 'inputField.errorMessage.pleaseEnterAValidLastName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid last name'
  },
  invalidFullName: {
    id: 'inputField.errorMessage.pleaseEnterAValidFullName',
    description: 'Error message if entered field is invalid',
    defaultMessage: 'Please enter a valid full name'
  },
  emptyCardNumber: {
    id: 'inputField.errorMessage.cardNumberEmpty',
    description: 'Error message if card number is empty',
    defaultMessage: 'Enter your card number'
  },
  emptyExpiryDate: {
    id: 'inputField.errorMessage.expiryDateEmpty',
    description: 'Error message if expiry date is empty',
    defaultMessage: 'Enter your card expiry date'
  },
  emptyCardCVV: {
    id: 'inputField.errorMessage.cardCVVEmpty',
    description: 'Error message if card cvv is empty',
    defaultMessage: 'Enter the card CVV/CVC'
  },
  emptyZipCode: {
    id: 'inputField.errorMessage.zipCodeEmpty',
    description: 'Error message if zip code is empty',
    defaultMessage: 'Enter your billing address ZIP code'
  },
  emptyAddressLineOne: {
    id: 'inputField.errorMessage.addressLineOneEmpty',
    description: 'Error message if address line one is empty',
    defaultMessage: 'Enter the first line of your address'
  },
  emptyCity: {
    id: 'inputField.errorMessage.cityEmpty',
    description: 'Error message if city is empty',
    defaultMessage: 'Enter your city'
  },
  emptyState: {
    id: 'inputField.errorMessage.stateEmpty',
    description: 'Error message if state is empty',
    defaultMessage: 'Select your state'
  },
  emptyAddressLineTwo: {
    id: 'inputField.errorMessage.addressLineTwoEmpty',
    description: 'Error message if address line two is empty',
    defaultMessage: 'Enter the second line of your address'
  }
});
exports.fieldsErrorMessages = fieldsErrorMessages;
var cardNumberFieldMessages = {
  fieldLabel: {
    id: 'inputField.label.cardNumber',
    description: 'Label for Card number field',
    defaultMessage: 'Card number'
  },
  fieldPlaceholder: {
    id: 'inputField.placeholder.cardNumber',
    description: 'Label for Card number field',
    defaultMessage: 'Card number'
  },
  invalidCardNumber: {
    id: 'inputField.errorMessage.invalidCardNumber',
    description: 'Error message if card number field is invalid',
    defaultMessage: 'Invalid card number. Check you have entered it correctly, or try a different payment method.'
  },
  cardTypeNotSupported: {
    id: 'inputField.errorMessage.cardTypeNotSupported',
    description: 'Error message if card type is not supported',
    defaultMessage: "Sorry, we don't accept this card type. Please try a different payment method."
  }
};
exports.cardNumberFieldMessages = cardNumberFieldMessages;
var cardExpiryFieldMessages = {
  label: {
    id: 'inputField.label.cardExpiry',
    description: 'Label for Card Expiry field',
    defaultMessage: 'Expiry date (MM/YY)'
  },
  placeholder: {
    id: 'inputField.placeholder.cardExpiry',
    description: 'Label for Card Expiry field',
    defaultMessage: 'MM/YY'
  },
  invalidCardExpiry: {
    id: 'inputField.errorMessage.invalidCardExpiry',
    description: 'Error message if card expiry field is invalid',
    defaultMessage: 'Enter a valid expiry date'
  },
  cardExpired: {
    id: 'inputField.errorMessage.cardExpired',
    description: 'Error message if card is expired',
    defaultMessage: 'Card expiry date must be in the future'
  }
};
exports.cardExpiryFieldMessages = cardExpiryFieldMessages;
var cardCVVFieldMessages = {
  label: {
    id: 'inputField.label.cardCVV',
    description: 'Label for Card CVV field',
    defaultMessage: 'CVV/CVC'
  },
  placeholder: {
    id: 'inputField.placeholder.cardCVV',
    description: 'Label for Card CVV field',
    defaultMessage: '3 or 4 digits security code'
  },
  invalidCardCVV: {
    id: 'inputField.errorMessage.invalidCardCVV',
    description: 'Error message if card cvv field is invalid',
    defaultMessage: 'Enter a valid CVV/CVC'
  }
};
exports.cardCVVFieldMessages = cardCVVFieldMessages;
var countryFieldMessages = {
  label: {
    id: 'inputField.label.country',
    description: 'Label for country',
    defaultMessage: 'Country'
  },
  placeholder: {
    id: 'inputField.placeholder.country',
    description: 'Label for Country field',
    defaultMessage: 'Select country'
  },
  invalidCountry: {
    id: 'inputField.errorMessage.invalidCountry',
    description: 'Error message if Country field is invalid',
    defaultMessage: 'Please enter a valid country'
  }
};
exports.countryFieldMessages = countryFieldMessages;
var zipCodeFieldMessages = {
  label: {
    id: 'inputField.label.zipcode',
    description: 'Label for zipcode',
    defaultMessage: 'ZIP code'
  },
  placeholder: {
    id: 'inputField.placeholder.zipCode',
    description: 'Label for ZIP Code field',
    defaultMessage: 'ZIP code'
  },
  invalidZipcode: {
    id: 'inputField.errorMessage.invalidZipcode',
    description: 'Error message if ZIP code field is invalid',
    defaultMessage: 'Enter a valid ZIP code'
  }
};
exports.zipCodeFieldMessages = zipCodeFieldMessages;
var addressLineFieldMessages = {
  label: {
    id: 'inputField.label.addressLine',
    description: 'Label for address line',
    defaultMessage: 'Address line 1'
  },
  placeholder: {
    id: 'inputField.placeholder.addressLine',
    description: 'Label for Address Line field',
    defaultMessage: 'Address line 1'
  },
  invalidAddressLine: {
    id: 'inputField.errorMessage.invalidAddressLine',
    description: 'Error message if Address Line field is invalid',
    defaultMessage: 'Please enter a valid address'
  },
  invalidAddressValue: {
    id: 'inputField.errorMessage.invalidAddressValue',
    description: 'Error message if Address Value field is invalid',
    defaultMessage: 'Please enter a valid address'
  }
};
exports.addressLineFieldMessages = addressLineFieldMessages;
var addressLineTwoFieldMessages = {
  label: {
    id: 'inputField.label.addressLineTwo',
    description: 'Label for address line two',
    defaultMessage: 'Address line 2 (Optional)'
  },
  placeholder: {
    id: 'inputField.placeholder.addressLineTwo',
    description: 'Label for Address Line field two',
    defaultMessage: 'Address line 2 (Optional)'
  },
  invalidAddressLine: {
    id: 'inputField.errorMessage.invalidAddressLineTwo',
    description: 'Error message if Address Line Two field is invalid',
    defaultMessage: 'Please enter a valid address'
  }
};
exports.addressLineTwoFieldMessages = addressLineTwoFieldMessages;
var stateFieldMessages = {
  label: {
    id: 'inputField.label.state',
    description: 'Label for state',
    defaultMessage: 'State'
  },
  placeholder: {
    id: 'inputField.placeholder.state',
    description: 'Label for State field',
    defaultMessage: 'State'
  },
  invalidState: {
    id: 'inputField.errorMessage.invalidState',
    description: 'Error message if State field is invalid',
    defaultMessage: 'Please enter a valid state'
  }
};
exports.stateFieldMessages = stateFieldMessages;
var cityFieldMessages = {
  label: {
    id: 'inputField.label.city',
    description: 'Label for city',
    defaultMessage: 'City'
  },
  placeholder: {
    id: 'inputField.placeholder.city',
    description: 'Label for City field',
    defaultMessage: 'City'
  },
  invalidCity: {
    id: 'inputField.errorMessage.invalidCity',
    description: 'Error message if city field is invalid',
    defaultMessage: 'Please enter a valid city'
  },
  invalidCityValue: {
    id: 'inputField.errorMessage.invalidCityValue',
    description: 'Error message if City Value is invalid',
    defaultMessage: 'Please enter a valid city'
  }
};
exports.cityFieldMessages = cityFieldMessages;
var nameErrorFieldMessages = {
  invalidNameField: {
    id: 'inputField.errorMessage.invalidName',
    description: 'Error message if Name field is invalid',
    defaultMessage: 'Please enter a valid Name'
  }
};
exports.nameErrorFieldMessages = nameErrorFieldMessages;
var payPalMessages = {
  initial: {
    id: 'paymentMethod.paypal.login.initial',
    description: 'PayPal login initial messsage',
    defaultMessage: 'To complete the checkout via PayPal, please login and validate the payment details'
  },
  success: {
    id: 'paymentMethod.paypal.login.success',
    description: 'PayPal login success messsage',
    defaultMessage: "You're paying with PayPal. Proceed to submit your order"
  }
};
exports.payPalMessages = payPalMessages;
var zipPayMessages = {
  minCartAmount: {
    id: 'paymentMethod.zipPay.minCartAmount',
    description: 'Minimum cart amount message',
    defaultMessage: 'The minimum order value to use Zip is {amount}'
  },
  maxCartAmount: {
    id: 'paymentMethod.zipPay.maxCartAmount',
    description: 'Maximum cart amount message',
    defaultMessage: 'The maximum order value to use Zip is {amount}'
  }
};
exports.zipPayMessages = zipPayMessages;
var inputFormInstruction = {
  instruction: {
    id: 'inputForm.instruction',
    description: 'Input form instruction',
    defaultMessage: 'All fields are required unless marked optional'
  }
};
exports.inputFormInstruction = inputFormInstruction;
var modalMessages = (0, _reactIntl.defineMessages)({
  modalTitle: {
    id: 'modal.title',
    description: 'Stored card modal title',
    defaultMessage: 'Are you sure want to delete?'
  },
  modalButtonDisagree: {
    id: 'modal.button.disagree',
    description: 'Modal button disagree text',
    defaultMessage: 'No'
  },
  modalButtonAgree: {
    id: 'modal.button.agree',
    description: 'Modal button agree text',
    defaultMessage: 'Yes'
  }
});
exports.modalMessages = modalMessages;
var addressLinePropsObj = {
  id: 'inputField.label.addressLine.',
  description: 'Label for First name field',
  defaultMessage: 'Address Line'
};
exports.addressLinePropsObj = addressLinePropsObj;
var addressLineTwoPropsObj = {
  id: 'inputField.label.addressLineTwo.',
  description: 'Label for address line two',
  defaultMessage: 'Address line 2 (Optional)'
};
exports.addressLineTwoPropsObj = addressLineTwoPropsObj;
var getCityPropsObj = {
  id: 'inputField.label.city.',
  description: 'Label for city',
  defaultMessage: 'City'
};
exports.getCityPropsObj = getCityPropsObj;
var getStatePropsObj = {
  id: 'inputField.label.state.',
  description: 'Label for state',
  defaultMessage: 'State',
  name: 'state',
  placeholderId: 'inputField.placeholder.state.',
  fieldError: {
    emptyError: {
      id: 'inputField.errorMessage.stateEmpty.',
      description: 'Error message if state is empty',
      defaultMessage: 'Select your state'
    },
    invalidError: {
      id: 'inputField.errorMessage.invalidState.',
      description: 'Error message if State field is invalid',
      defaultMessage: 'Please enter a valid state'
    }
  }
};
exports.getStatePropsObj = getStatePropsObj;
var getZipCodePropsObj = {
  id: 'inputField.label.zipcode.',
  description: 'Label for zipcode',
  defaultMessage: 'ZIP code',
  fieldError: {
    emptyError: {
      id: 'inputField.errorMessage.zipCodeEmpty.',
      description: 'Error message if Postal code is empty',
      defaultMessage: 'Enter your billing address Postal code'
    },
    invalidError: {
      id: 'inputField.errorMessage.invalidZipcode.',
      description: 'Error message if Postal code field is invalid',
      defaultMessage: 'Enter a valid Postal code'
    }
  }
};
exports.getZipCodePropsObj = getZipCodePropsObj;